import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    // slider Accès rapides
    const accessSlideshow = document.querySelector('.access .swiper-container') !== null;
                
    if (accessSlideshow) {
        let accessSlides = document.querySelectorAll('.access .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let accessConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,
            slidesPerView: "auto",
            slidesPerColumn: 2,

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.access .swiper-button-next`,
                prevEl: `.access .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            }
        }

        let swiperaccess = new Swiper('.access .swiper-container', accessConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de accessSlides

        const postsNavigationAccess = document.querySelector('.access__navigation');

        function checkScreenSizeAccess() {
            const screenSizeAccesss = window.innerWidth;
            const accessSlides = document.querySelectorAll('.access .swiper-container .swiper-slide').length;

            if (screenSizeAccesss > 640 && accessSlides <= 2) {
                postsNavigationAccess.classList.add('disable');
            } else if (screenSizeAccesss <= 640 && accessSlides <= 1) {
                postsNavigationAccess.classList.add('disable');
            } else {
                if (postsNavigationAccess.classList.contains('disable')) {
                    postsNavigationAccess.classList.remove('disable');
                }
            }
        }

        checkScreenSizeAccess();

        window.addEventListener('resize', checkScreenSizeAccess);
    }

    // slider Actualités
    const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;
                
    if (postsSlideshow) {
        let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let postsConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,
            slidesPerView: 'auto',

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.posts .swiper-button-next`,
                prevEl: `.posts .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            }
        }

        let swiperposts = new Swiper('.posts .swiper-container', postsConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de postsSlides

        const postsNavigationPosts = document.querySelector('.posts__navigation');

        function checkScreenSizePosts() {
            const screenSizePosts = window.innerWidth;
            const postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

            if (screenSizePosts > 640 && postsSlides <= 2) {
                postsNavigationPosts.classList.add('disable');
            } else if (screenSizePosts <= 640 && postsSlides <= 1) {
                postsNavigationPosts.classList.add('disable');
            } else {
                if (postsNavigationPosts.classList.contains('disable')) {
                    postsNavigationPosts.classList.remove('disable');
                }
            }
        }

        checkScreenSizePosts();

        window.addEventListener('resize', checkScreenSizePosts);
    }

    // slider Agenda
    const eventsSlideshow = document.querySelector('.events .swiper-container') !== null;
                
    if (eventsSlideshow) {
        let eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let eventsConfig = {
            effect : 'slide',
            grabCursor : 'false',
            speed: 700,
            loop: false,
            slidesPerView: 'auto',

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.events .swiper-button-next`,
                prevEl: `.events .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            }
        }

        let swiperevents = new Swiper('.events .swiper-container', eventsConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de eventsSlides

        const postsNavigationEvents = document.querySelector('.events__navigation');

        function checkScreenSizeEvents() {
            const screenSizeEvents = window.innerWidth;
            const eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;

            if (screenSizeEvents > 640 && eventsSlides <= 2) {
                postsNavigationEvents.classList.add('disable');
            } else if (screenSizeEvents <= 640 && eventsSlides <= 1) {
                postsNavigationEvents.classList.add('disable');
            } else {
                if (postsNavigationEvents.classList.contains('disable')) {
                    postsNavigationEvents.classList.remove('disable');
                }
            }
        }

        checkScreenSizeEvents();

        window.addEventListener('resize', checkScreenSizeEvents);
    }

}
